"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVirtualElement = void 0;
var dom_utilities_1 = require("@fluentui/dom-utilities");
Object.defineProperty(exports, "isVirtualElement", { enumerable: true, get: function () { return dom_utilities_1.isVirtualElement; } });
//# sourceMappingURL=isVirtualElement.js.map